/* =============================================================
   Fi Akla — Delivery + Allergy Gate (assets/fi-akla-delivery-slot.js)
   Single source of truth for required cart declarations.
   Cart attributes are the only source of truth for persistence.
   ============================================================= */
 
/* ── Global duplicate-init guard ─────────────────────────────
   The entire script is skipped if it has already run.
   This covers listeners, MutationObserver and timers.        */
if (window.fiAklaDeliverySlotLoaded) {
  // Script already initialised — do nothing.
} else {
  window.fiAklaDeliverySlotLoaded = true;
 
  (function () {
    'use strict';
 
    /* ── Constants ─────────────────────────────────────────── */
 
    var WINDOWS = [
      { label: '12–3 PM', window: '12:00–15:00' },
      { label: '3–6 PM',  window: '15:00–18:00' },
      { label: '6–9 PM',  window: '18:00–21:00' }
    ];
 
    var ALLERGENS = [
      'Peanuts',
      'Tree nuts',
      'Eggs',
      'Dairy',
      'Sesame',
      'Fish',
      'Soy',
      'Shellfish',
      'Celery',
      'Wheat',
      'Mustard'
    ];
 
    /* ── Locale-aware cart route helper ────────────────────── */
 
    function getCartRoute(path) {
      var root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
      return root + path;
    }
 
    /* ── Shared mutable state ──────────────────────────────── */
 
    var slotPersisted       = false;
    var allergyPersisted    = false;
    var pendingSlotSave     = null;
    var pendingAllergySave  = null;
    var changeSeq           = 0;
    var allergySeq          = 0;
    var initSeq             = 0;
    var allergyInputTimer   = null;
    var cartMode             = 'empty';
    var compositionKnown     = false;
 
    /* ── Cairo-time helper ─────────────────────────────────── */
 
    function getCairoNow() {
      var now   = new Date();
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone:  'Africa/Cairo',
        year:      'numeric',
        month:     'numeric',
        day:       'numeric',
        hour:      'numeric',
        minute:    'numeric',
        hour12:    false,
        hourCycle: 'h23'
      }).formatToParts(now);
 
      var p = {};
      parts.forEach(function (part) {
        if (part.type !== 'literal') p[part.type] = parseInt(part.value, 10);
      });
 
      var cairoMidnightUTC = new Date(Date.UTC(p.year, p.month - 1, p.day));
 
      return {
        year:   p.year,
        month:  p.month,
        day:    p.day,
        hour:   p.hour,
        minute: p.minute,
        dow:    cairoMidnightUTC.getUTCDay()  // 0 = Sun, 3 = Wed
      };
    }
 
    /* ── Cycle date calculation ──────────────────────────────
       Cutoff: Wednesday 21:00 Cairo.
       Delivery days: the Sunday (+4d) and Wednesday (+7d)
       that follow the cutoff Wednesday.                      */
 
    function getCycleDates(cairo) {
      var dow          = cairo.dow;
      var daysUntilWed = (3 - dow + 7) % 7;
 
      var cutoffPassed =
        dow === 3 &&
        (cairo.hour > 21 || (cairo.hour === 21 && cairo.minute >= 0));
 
      if (cutoffPassed) daysUntilWed = 7;
 
      var cutoffWed = new Date(Date.UTC(cairo.year, cairo.month - 1, cairo.day));
      cutoffWed.setUTCDate(cutoffWed.getUTCDate() + daysUntilWed);
 
      var sundayDate = new Date(cutoffWed);
      sundayDate.setUTCDate(cutoffWed.getUTCDate() + 4);
 
      var wednesdayDate = new Date(cutoffWed);
      wednesdayDate.setUTCDate(cutoffWed.getUTCDate() + 7);
 
      return { sunday: toISODate(sundayDate), wednesday: toISODate(wednesdayDate) };
    }
 
    function toISODate(d) {
      return d.getUTCFullYear() + '-' +
        String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
        String(d.getUTCDate()).padStart(2, '0');
    }
 
    function formatShortDate(isoDate) {
      var parts = isoDate.split('-');
      var d = new Date(Date.UTC(
        parseInt(parts[0], 10),
        parseInt(parts[1], 10) - 1,
        parseInt(parts[2], 10)
      ));
      return d.toLocaleDateString('en-GB', {
        timeZone: 'UTC',
        weekday:  'long',
        day:      'numeric',
        month:    'short'
      });
    }
 
    /* ── Option list ───────────────────────────────────────── */
 
    function buildOptions(cycleDates) {
      var options = [
        { value: '', text: 'Select a delivery slot', date: '', window: '', disabled: true }
      ];
      [cycleDates.sunday, cycleDates.wednesday].forEach(function (iso) {
        var dateLabel = formatShortDate(iso);
        WINDOWS.forEach(function (w) {
          var slotLabel = dateLabel + ' · ' + w.label;
          options.push({ value: slotLabel, text: slotLabel, date: iso, window: w.window, disabled: false });
        });
      });
      return options;
    }
 
    function findOption(value, options) {
      for (var i = 0; i < options.length; i++) {
        if (options[i].value === value) return options[i];
      }
      return null;
    }
 
    /* ── DOM helpers ───────────────────────────────────────── */
 
    function getSelect() {
      return (
        document.getElementById('CartDrawer-DeliverySlot') ||
        document.querySelector('select[name="attributes[Delivery slot]"]')
      );
    }
 
    function getAllergyFieldset() {
      return document.getElementById('CartDrawer-AllergyDeclaration');
    }
 
    function getAllergyStatus() {
      return document.querySelector('input[name="fi-akla-allergy-status"]:checked');
    }
 
    function getAllergenInputs() {
      return Array.prototype.slice.call(
        document.querySelectorAll('input[name="fi-akla-allergen"]')
      );
    }
 
    function getAllergyOtherInput() {
      return document.querySelector('[data-allergy-other-text]');
    }
 
    function getAllergyNotesInput() {
      return document.querySelector('[data-allergy-notes]');
    }
 
    function getCheckout(selectEl) {
      /* Try scoped lookup inside the nearest cart container first */
      if (selectEl) {
        var container = selectEl.closest(
          'cart-drawer, [id*="cart-drawer"], .cart-drawer, ' +
          '.cart-drawer__summary, .cart__summary, [data-cart-summary]'
        );
        if (container) {
          var scoped = container.querySelector('button[name="checkout"][form="cart-form"]');
          if (scoped) return scoped;
        }
      }
      /* Global fallback */
      return (
        document.getElementById('checkout') ||
        document.querySelector('button[name="checkout"][form="cart-form"]')
      );
    }
 
    function isServiceItem(item) {
      var properties = item && item.properties ? item.properties : {};
      return !!(item && (
        item.product_type === 'Service' ||
        properties['_Booking type'] === 'Invite Us Over' ||
        /^invite-us-over-/.test(item.handle || '')
      ));
    }

    function isMealPassItem(item) {
      return !!(item && (
        item.product_type === 'Meal Pass' ||
        item.handle === 'fi-akla-meal-pass' ||
        /^PASS-(LIGHT|REGULAR|FULL)-(4W|8W|12W)$/.test(item.sku || '')
      ));
    }

    function getCartMode(cart) {
      var hasService = false;
      var hasWeekly = false;
      var hasMealPass = false;
      var items = cart && cart.items ? cart.items : [];
      for (var i = 0; i < items.length; i++) {
        if (isServiceItem(items[i])) hasService = true;
        else if (isMealPassItem(items[i])) hasMealPass = true;
        else hasWeekly = true;
      }
      var categoryCount =
        (hasService ? 1 : 0) +
        (hasWeekly ? 1 : 0) +
        (hasMealPass ? 1 : 0);
      if (categoryCount > 1) return 'mixed';
      if (hasService) return 'service';
      if (hasMealPass) return 'meal-pass';
      if (hasWeekly) return 'weekly';
      return 'empty';
    }

    function syncCartModeUI() {
      var details = document.querySelector('[data-fi-akla-cart-mode]');
      if (details) details.setAttribute('data-fi-akla-cart-mode', cartMode);
      var slotWrap = document.querySelector('.cart-delivery-slot');
      if (slotWrap) slotWrap.hidden = cartMode !== 'weekly';
      var allergyFieldset = getAllergyFieldset();
      if (allergyFieldset) allergyFieldset.hidden = cartMode === 'meal-pass';
      var mixedError = document.getElementById('CartDrawer-MixedCartError');
      if (mixedError) mixedError.hidden = cartMode !== 'mixed';
    }

    function setSelectDisabled(disabled) {
      var el = getSelect();
      if (el) el.disabled = disabled;
    }
 
    function setAllergyControlsDisabled(disabled) {
      var fieldset = getAllergyFieldset();
      if (!fieldset) return;
 
      fieldset.setAttribute('aria-busy', disabled ? 'true' : 'false');
      var controls = fieldset.querySelectorAll('input, textarea');
      for (var i = 0; i < controls.length; i++) {
        controls[i].disabled = disabled;
      }
    }
 
    function updateCheckoutState(contextEl) {
      var checkout = getCheckout(contextEl);
      if (!checkout) return;
 
      var mealPassReady = cartMode === 'meal-pass';
      var slotReady =
        cartMode === 'service' ||
        mealPassReady ||
        (cartMode === 'weekly' && slotPersisted);
      var allergyReady = mealPassReady || allergyPersisted;
      checkout.disabled = !(
        compositionKnown &&
        cartMode !== 'empty' &&
        cartMode !== 'mixed' &&
        slotReady &&
        allergyReady &&
        pendingSlotSave === null &&
        pendingAllergySave === null
      );
    }
 
    function showError(id, visible) {
      var el = document.getElementById(id);
      if (el) el.hidden = !visible;
    }
 
    /* ── Populate the <select> ─────────────────────────────── */
 
    function populateSelector(options, restoredValue) {
      var select = getSelect();
      if (!select) return;
 
      select.innerHTML = '';
      options.forEach(function (opt) {
        var el         = document.createElement('option');
        el.value       = opt.value;
        el.textContent = opt.text;
        if (opt.disabled) el.disabled = true;
        select.appendChild(el);
      });
 
      if (restoredValue && findOption(restoredValue, options)) {
        select.value = restoredValue;
      } else {
        select.value = '';
        if (select.options.length) select.options[0].selected = true;
      }
    }
 
    /* ── Cart API ──────────────────────────────────────────── */
 
    function updateCartAttributes(attrs) {
      return fetch(getCartRoute('cart/update.js'), {
        method:      'POST',
        credentials: 'same-origin',
        cache:       'no-store',
        headers:     { 'Content-Type': 'application/json', Accept: 'application/json' },
        body:        JSON.stringify({ attributes: attrs })
      }).then(function (res) {
        if (!res.ok) {
          return res.text().then(function (body) {
            return Promise.reject(new Error('HTTP ' + res.status + ' — ' + body));
          });
        }
        return res.json().then(function (cart) {
          var a = cart.attributes || {};
          /* Verify every requested attribute, for delivery and allergy saves. */
          var keys = Object.keys(attrs);
          for (var i = 0; i < keys.length; i++) {
            if ((a[keys[i]] || '') !== (attrs[keys[i]] || '')) {
              return Promise.reject(new Error(
                'Attribute mismatch after save. Got: ' + JSON.stringify(a)
              ));
            }
          }
          return cart;
        });
      });
    }
 
    function saveSlot(slotLabel, isoDate, windowStr) {
      return updateCartAttributes({
        'Delivery slot':    slotLabel,
        '_delivery_date':   isoDate,
        '_delivery_window': windowStr
      });
    }
 
    function clearSlot() {
      return updateCartAttributes({
        'Delivery slot':    '',
        '_delivery_date':   '',
        '_delivery_window': ''
      });
    }
 
    function fetchCartState() {
      return fetch(getCartRoute('cart.js'), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
    }
 
    /* ── Allergy declaration helpers ───────────────────────── */
 
    function hideAllergyErrors() {
      showError('CartDrawer-AllergyDeclarationError', false);
      showError('CartDrawer-AllergySelectionError',   false);
      showError('CartDrawer-AllergyOtherError',       false);
      showError('CartDrawer-AllergySaveError',        false);
    }
 
    function syncAllergyVisibility() {
      var status       = getAllergyStatus();
      var details      = document.getElementById('CartDrawer-AllergyDetails');
      var otherWrap    = document.getElementById('CartDrawer-AllergyOtherWrap');
      var yesInput     = document.querySelector('[data-allergy-yes]');
      var otherControl = document.querySelector('[data-allergen-other]');
      var showDetails  = !!(status && status.value === 'Allergies declared');
      var showOther    = !!(showDetails && otherControl && otherControl.checked);
 
      if (details) details.hidden = !showDetails;
      if (otherWrap) otherWrap.hidden = !showOther;
      if (yesInput) yesInput.setAttribute('aria-expanded', showDetails ? 'true' : 'false');
      if (otherControl) otherControl.setAttribute('aria-expanded', showOther ? 'true' : 'false');
      var otherInput = getAllergyOtherInput();
      if (otherInput) otherInput.required = showOther;
    }
 
    function clearAllergyUI() {
      var statuses = document.querySelectorAll('input[name="fi-akla-allergy-status"]');
      var allergens = getAllergenInputs();
      var other = getAllergyOtherInput();
      var notes = getAllergyNotesInput();
      var i;
 
      for (i = 0; i < statuses.length; i++) statuses[i].checked = false;
      for (i = 0; i < allergens.length; i++) allergens[i].checked = false;
      if (other) other.value = '';
      if (notes) notes.value = '';
      syncAllergyVisibility();
    }
 
    function parseStoredAllergies(rawValue) {
      var result = { standard: [], other: '' };
      if (!rawValue) return result;
 
      var pieces = rawValue.split(',');
      var otherPieces = [];
      var readingOther = false;
 
      for (var i = 0; i < pieces.length; i++) {
        var piece = pieces[i].trim();
        if (!piece) continue;
 
        if (piece.indexOf('Other:') === 0) {
          readingOther = true;
          otherPieces.push(piece.slice(6).trim());
        } else if (!readingOther && ALLERGENS.indexOf(piece) !== -1) {
          result.standard.push(piece);
        } else {
          readingOther = true;
          otherPieces.push(piece);
        }
      }
 
      result.other = otherPieces.join(', ').trim();
      return result;
    }
 
    function readAllergyUI() {
      var statusInput = getAllergyStatus();
      var result = {
        valid: false,
        status: '',
        allergies: '',
        notes: '',
        errorId: 'CartDrawer-AllergyDeclarationError',
        focusEl: document.querySelector('input[name="fi-akla-allergy-status"]')
      };
 
      if (!statusInput) return result;
 
      result.status = statusInput.value;
 
      if (result.status === 'No known allergies') {
        result.valid = true;
        result.allergies = '';
        result.notes = '';
        result.errorId = '';
        result.focusEl = null;
        return result;
      }
 
      var selected = getAllergenInputs().filter(function (input) {
        return input.checked;
      });
 
      if (selected.length === 0) {
        result.errorId = 'CartDrawer-AllergySelectionError';
        result.focusEl = getAllergenInputs()[0] || statusInput;
        return result;
      }
 
      var values = [];
      var otherSelected = false;
      for (var i = 0; i < selected.length; i++) {
        if (selected[i].value === 'Other') {
          otherSelected = true;
        } else {
          values.push(selected[i].value);
        }
      }
 
      var otherInput = getAllergyOtherInput();
      var otherText = otherInput ? otherInput.value.trim() : '';
      if (otherSelected && !otherText) {
        result.errorId = 'CartDrawer-AllergyOtherError';
        result.focusEl = otherInput;
        return result;
      }
 
      if (otherSelected) values.push('Other: ' + otherText);
 
      var notesInput = getAllergyNotesInput();
      result.valid = true;
      result.allergies = values.join(', ');
      result.notes = notesInput ? notesInput.value.trim() : '';
      result.errorId = '';
      result.focusEl = null;
      return result;
    }
 
    function restoreAllergyUI(attrs) {
      clearAllergyUI();
 
      var status = attrs['Allergy status'] || '';
      var rawAllergies = attrs['Allergies'] || '';
      var notes = attrs['Allergy notes'] || '';
      var statusInput = document.querySelector(
        'input[name="fi-akla-allergy-status"][value="' + status + '"]'
      );
 
      if (!statusInput) return false;
      statusInput.checked = true;
 
      if (status === 'Allergies declared') {
        var parsed = parseStoredAllergies(rawAllergies);
        var allergenInputs = getAllergenInputs();
        for (var i = 0; i < allergenInputs.length; i++) {
          if (parsed.standard.indexOf(allergenInputs[i].value) !== -1) {
            allergenInputs[i].checked = true;
          }
          if (allergenInputs[i].value === 'Other' && parsed.other) {
            allergenInputs[i].checked = true;
          }
        }
 
        var otherInput = getAllergyOtherInput();
        if (otherInput) otherInput.value = parsed.other;
        var notesInput = getAllergyNotesInput();
        if (notesInput) notesInput.value = notes;
      }
 
      syncAllergyVisibility();
      var current = readAllergyUI();
 
      if (status === 'No known allergies') {
        return current.valid && !rawAllergies && !notes;
      }
 
      return current.valid && current.allergies === rawAllergies && current.notes === notes;
    }
 
    function saveAllergyDeclaration(status, allergies, notes) {
      return updateCartAttributes({
        'Allergy status': status,
        'Allergies':      allergies,
        'Allergy notes':  notes
      });
    }
 
    function showAllergyValidationError(result) {
      hideAllergyErrors();
      if (result && result.errorId) showError(result.errorId, true);
      if (result && result.focusEl) result.focusEl.focus();
    }
 
    function persistAllergyFromUI(showValidation) {
      hideAllergyErrors();
      syncAllergyVisibility();
 
      var result = readAllergyUI();
      allergyPersisted = false;
      allergySeq += 1;
      initSeq += 1;
      var myAllergySeq = allergySeq;
 
      if (!result.valid && showValidation) {
        showAllergyValidationError(result);
      }
 
      /* Clear any previously saved declaration when the new UI is incomplete. */
      var attrs = result.valid
        ? {
            status: result.status,
            allergies: result.allergies,
            notes: result.notes
          }
        : { status: '', allergies: '', notes: '' };
 
      /* With no selection at all, there is nothing stale to clear on first load. */
      if (!result.valid && !result.status) {
        pendingAllergySave = null;
        updateCheckoutState(getAllergyFieldset());
        return Promise.resolve(false);
      }
 
      pendingAllergySave = { seq: myAllergySeq };
      setAllergyControlsDisabled(true);
      updateCheckoutState(getAllergyFieldset());
 
      return saveAllergyDeclaration(attrs.status, attrs.allergies, attrs.notes)
        .then(function () {
          if (myAllergySeq !== allergySeq) return false;
          pendingAllergySave = null;
          allergyPersisted = result.valid;
          setAllergyControlsDisabled(false);
          syncAllergyVisibility();
          updateCheckoutState(getAllergyFieldset());
          return result.valid;
        })
        .catch(function (err) {
          console.error('[Fi Akla] Failed to save allergy declaration:', err.message);
          if (myAllergySeq !== allergySeq) return false;
          pendingAllergySave = null;
          allergyPersisted = false;
          setAllergyControlsDisabled(false);
          syncAllergyVisibility();
          updateCheckoutState(getAllergyFieldset());
          showError('CartDrawer-AllergySaveError', true);
          return false;
        });
    }
 
    /* ── init() ────────────────────────────────────────────
       Each call gets its own sequence number.
       The fetchCartState() callback checks whether its
       sequence is still the latest before touching the DOM.  */
 
    function init() {
      var select = getSelect();
      var allergyFieldset = getAllergyFieldset();
      var checkout = getCheckout(select);
      if (!checkout) return;
 
      /* Never restore stale server state over a save that is still in flight. */
      if (pendingSlotSave !== null || pendingAllergySave !== null) {
        debouncedInit();
        return;
      }
 
      /* Increment init counter and capture locally */
      initSeq += 1;
      var myInitSeq = initSeq;
 
      /* Immediately disable required controls while fetching. */
      slotPersisted = false;
      allergyPersisted = false;
      compositionKnown = false;
      cartMode = 'empty';
      setSelectDisabled(true);
      setAllergyControlsDisabled(true);
      updateCheckoutState(select);
      showError('CartDrawer-DeliverySlotError',     false);
      showError('CartDrawer-DeliverySlotSaveError', false);
      hideAllergyErrors();
 
      var cairo      = getCairoNow();
      var cycleDates = getCycleDates(cairo);
      var options    = buildOptions(cycleDates);
 
      fetchCartState()
        .then(function (cart) {
          if (myInitSeq !== initSeq) return;
          var attrs = cart.attributes || {};
          cartMode = getCartMode(cart);
          compositionKnown = true;
          syncCartModeUI();

          var savedSlot = attrs['Delivery slot'] || '';
          var savedDate = attrs['_delivery_date'] || '';
          var savedWindow = attrs['_delivery_window'] || '';
          var match = savedSlot ? findOption(savedSlot, options) : null;
          var slotValid = !!(
            cartMode === 'weekly' &&
            match &&
            match.date && match.date === savedDate &&
            match.window && match.window === savedWindow
          );

          if (cartMode === 'meal-pass') {
            slotPersisted = true;
            allergyPersisted = true;
          } else {
            slotPersisted = slotValid;
            if (cartMode === 'weekly') populateSelector(options, slotValid ? savedSlot : '');
            allergyPersisted = restoreAllergyUI(attrs);
          }
          setSelectDisabled(false);
          setAllergyControlsDisabled(false);
          syncAllergyVisibility();
          updateCheckoutState(select || allergyFieldset);
 
          /* Invalid/stale values stay server-side until the customer replaces them.
             Avoiding an untracked background clear prevents it racing a new save. */
        })
        .catch(function (err) {
          if (myInitSeq !== initSeq) return;
          console.error('[Fi Akla] Failed to fetch cart:', err);
          slotPersisted = false;
          allergyPersisted = false;
          compositionKnown = false;
          cartMode = 'empty';
          syncCartModeUI();
          populateSelector(options, '');
          clearAllergyUI();
          setSelectDisabled(false);
          setAllergyControlsDisabled(false);
          updateCheckoutState(select);
        });
    }
 
    /* ── Debounced init ────────────────────────────────────── */
 
    var initTimer = null;
    function debouncedInit() {
      clearTimeout(initTimer);
      initTimer = setTimeout(init, 80);
    }
 
    /* ── Slot change handler ───────────────────────────────── */
 
    function onSlotChange(event) {
      /* Match by attribute — not by element identity */
      var select = event.target;
      if (
        !select ||
        !select.matches ||
        !select.matches('select[name="attributes[Delivery slot]"]')
      ) {
        return;
      }
 
      showError('CartDrawer-DeliverySlotError',     false);
      showError('CartDrawer-DeliverySlotSaveError', false);
 
      slotPersisted = false;
 
      /* Bump both counters so any in-flight init() is treated as stale */
      changeSeq += 1;
      initSeq   += 1;
      var myChangeSeq = changeSeq;
 
      var selectedValue = select.value;
 
      if (!selectedValue) {
        pendingSlotSave = null;
        updateCheckoutState(select);
        clearSlot().catch(function (err) {
          console.error('[Fi Akla] Failed to clear slot:', err);
        });
        return;
      }
 
      var cairo   = getCairoNow();
      var options = buildOptions(getCycleDates(cairo));
      var match   = findOption(selectedValue, options);
 
      if (!match || !match.date) {
        select.value  = '';
        slotPersisted = false;
        pendingSlotSave = null;
        updateCheckoutState(select);
        showError('CartDrawer-DeliverySlotSaveError', true);
        return;
      }
 
      select.disabled = true;
      pendingSlotSave = { seq: myChangeSeq };
      updateCheckoutState(select);
 
      saveSlot(match.value, match.date, match.window)
        .then(function () {
          if (myChangeSeq !== changeSeq) return;
          pendingSlotSave = null;
          slotPersisted = true;
          select.disabled = false;
          updateCheckoutState(select);
          showError('CartDrawer-DeliverySlotError',     false);
          showError('CartDrawer-DeliverySlotSaveError', false);
        })
        .catch(function (err) {
          console.error('[Fi Akla] Failed to save slot:', err.message);
          if (myChangeSeq !== changeSeq) return;
          pendingSlotSave = null;
          slotPersisted = false;
          select.value = '';
          select.disabled = false;
          updateCheckoutState(select);
          showError('CartDrawer-DeliverySlotSaveError', true);
        });
    }
 
    /* ── Allergy declaration handlers ─────────────────────── */
 
    function onAllergyChange(event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (!target.matches('[data-allergy-status], [data-allergen]')) return;
 
      hideAllergyErrors();
 
      if (target.matches('[data-allergy-status]') && target.value === 'No known allergies') {
        var allergens = getAllergenInputs();
        for (var i = 0; i < allergens.length; i++) allergens[i].checked = false;
        var other = getAllergyOtherInput();
        var notes = getAllergyNotesInput();
        if (other) other.value = '';
        if (notes) notes.value = '';
      }
 
      if (target.matches('[data-allergen-other]') && !target.checked) {
        var otherInput = getAllergyOtherInput();
        if (otherInput) otherInput.value = '';
      }
 
      syncAllergyVisibility();
      persistAllergyFromUI(false);
    }
 
    function onAllergyInput(event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (!target.matches('[data-allergy-other-text], [data-allergy-notes]')) return;
 
      hideAllergyErrors();
      allergyPersisted = false;
      updateCheckoutState(target);
      clearTimeout(allergyInputTimer);
      allergyInputTimer = setTimeout(function () {
        persistAllergyFromUI(false);
      }, 400);
    }
 
    /* ── Form submit guard ─────────────────────────────────── */
 
    function onFormSubmit(event) {
      var form = event.target;
      if (!form || form.id !== 'cart-form') return;

      var select = getSelect();
      var allergyFieldset = getAllergyFieldset();

      var mixedError = document.getElementById('CartDrawer-MixedCartError');
      if (!compositionKnown || cartMode === 'mixed' || cartMode === 'empty') {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (mixedError) {
          mixedError.hidden = cartMode !== 'mixed';
          if (cartMode === 'mixed') mixedError.focus();
        }
        return;
      }

      if (cartMode === 'meal-pass') return;
      if (!allergyFieldset) return;

      var allergy = readAllergyUI();
      var slotReady = cartMode === 'service' || !!(
        cartMode === 'weekly' && select && select.value &&
        slotPersisted && pendingSlotSave === null
      );
      var ready = !!(
        slotReady && allergy.valid && allergyPersisted &&
        pendingAllergySave === null
      );
      if (ready) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (cartMode === 'weekly' && select && !select.value) {
        showError('CartDrawer-DeliverySlotError', true);
        select.focus();
        return;
      }
      if (cartMode === 'weekly' && select && (!slotPersisted || pendingSlotSave !== null)) {
        showError('CartDrawer-DeliverySlotSaveError', true);
        select.focus();
        return;
      }
      if (!allergy.valid) {
        showAllergyValidationError(allergy);
        return;
      }
      showError('CartDrawer-AllergySaveError', true);
      allergyFieldset.focus();
    }
 
    /* ── MutationObserver — detect cart drawer appearing ───── */
 
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            node.querySelector &&
            (node.querySelector('select[name="attributes[Delivery slot]"]') ||
             node.querySelector('#CartDrawer-AllergyDeclaration') ||
             node.id === 'CartDrawer-DeliverySlot' ||
             node.id === 'CartDrawer-AllergyDeclaration')
          ) {
            debouncedInit();
            return;
          }
        }
      }
    });
 
    observer.observe(document.body, { childList: true, subtree: true });
 
    /* ── Register event listeners (once, guarded by outer if) ─ */
 
    document.addEventListener('change', onSlotChange);
    document.addEventListener('change', onAllergyChange);
    document.addEventListener('input', onAllergyInput);
    document.addEventListener('submit', onFormSubmit, true);
    document.addEventListener('cart:refresh', debouncedInit);
    document.addEventListener('cart:updated', debouncedInit);
    document.addEventListener('cart:open',    debouncedInit);
 
    /* ── Kick off ──────────────────────────────────────────── */
 
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', debouncedInit);
    } else {
      debouncedInit();
    }
 
  })();
}
